import { getJSONWithPreload } from 'bv-fetch';
import { loggedIn } from 'bv-helpers/session';
import { locale } from 'bv-i18n';

export default () => getJSONWithPreload('/sportsbook_components/home_components/components', {
  c: locale(),
  l: loggedIn(),
  mode: 'light_casino',
});
